import React from "react";
import { Route, Switch, Router } from 'react-router-dom';
import history from './configureHistory';
import { render } from "react-dom";
import TrackDonationApp from "../trackdonation/components/trackdonationContainer";

const validateCountry = (document.getElementsByTagName('html')[0].getAttribute('country')).toUpperCase();
const domainCC = window.location.pathname.split("/")[1].toUpperCase();
let countryCode = '';

if (validateCountry === domainCC) {
	countryCode = '/' + validateCountry;
}

let routes = [{ path: countryCode + '/givingfund/donationtracker', component: TrackDonationApp }, 
			{ path: countryCode + '/givingfund/donationtrackermember', component: TrackDonationApp }];
let routeComponents = routes.map(({path, component}, key) => <Route exact path={path} component={component} key={key} />);
render((
	<Router history={history}>
		<Switch>
			{routeComponents}
		</Switch>
	</Router>
), document.getElementById('givingfundWrapper'));